<style>
	.collapse-a:before {
		font-family: "Font Awesome 5 Free";
		content: "\f067";
		margin-left: 10px
	}

	.collapse-a .collapse-a-title:before {
		content: "جزئیات بیشتر";
	}

	.collapse-a.lessDetails:before {
		font-family: "Font Awesome 5 Free";
		content: "\f068";
		margin-left: 10px
	}

	.collapse-a.lessDetails .collapse-a-title:before {
		content: "جزئیات کمتر";
	}	
</style>
<template>
	<div id="page">
		<checkListFolder-modal v-if="showFolderModal" @close="showFolderModal = false" :CheckListUserId="checkListModel.userId" :checkListFolder="selectedFolder" @saveFolder="saveFolderChanges"></checkListFolder-modal>
		<checkListMoveList-modal v-if="showMoveListModal" @close="showMoveListModal = false" :checkListFolderId="selectedFolder.checkListFolderId" :checkListId="checkListModel.checkListId" @selectItem="moveFolder"></checkListMoveList-modal>

		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
					ثبت چک لیست
					<button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style mb-3">
				<div class="content mb-0">
					<div class="row mb-0 px-2">
						<div class="col-6 px-1">
							<div class="input-style input-style-2 has-icon input-required mb-1">
								<i class="input-icon fa fa-calendar color-magenta2-light"></i>
								<span class="color-highlight" :class="{'input-style-1-active' : checkListModel.checkListDate!==null}">تاریخ</span>
								<input type="text" class="form-control ltr d-inline-block" v-model="checkListModel.checkListDate" id="endDT" @input="v$.checkListModel.checkListDate.$touch()" :class="{invalid:v$.checkListModel.checkListDate.$error}" />
								<p class="text-danger" v-if="v$.checkListModel.checkListDate.required.$invalid && v$.checkListModel.checkListDate.$dirty">لطفا تاریخ را وارد کنید.</p>
							</div>
						</div>
						<div class="col-6 px-1">
							<div class="input-style input-style-2 has-icon input-required mb-1">
								<i class="input-icon fa fa-check color-magenta2-light"></i>
								<span class="color-highlight" :class="{'input-style-1-active' : checkListModel.subject!==null}">عنوان</span>
								<input class="form-control" type="text" v-model="checkListModel.subject" @input="v$.checkListModel.subject.$touch()" :class="{invalid:v$.checkListModel.subject.$error}">
								<p class="text-danger" v-if="v$.checkListModel.subject.required.$invalid && v$.checkListModel.subject.$dirty">لطفا عنوان را وارد کنید.</p>
							</div>
						</div>




					</div>

					<div class="mb-3 mt-2">
						<!--@option:cleared="ChangeWorkGroup"-->
						<v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="checkListModel.workGroupId" @option:selected="onChangeWorkGroup">
							<template slot="option">
								<div class="d-center">
									{{ option.title }}
								</div>
							</template>
						</v-select>
					</div>
					<div class="mb-3" id="drpUserId" style="display:none">
						<div class="d-flex">
							<div class="w-100">
								<v-select dir="rtl" v-model="checkListModel.userId" label="title" placeholder="چک لیست برای" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
									<template v-slot="option">
										<div class="d-center">
											{{ option.title }}
										</div>
									</template>
								</v-select>
							</div>
						</div>
						<p class="text-danger" v-if="v$.checkListModel.userId.required.$invalid && v$.checkListModel.userId.$dirty">لطفا چک لیست برای را انتخاب کنید.</p>
					</div>


					<div class="mb-3">
						<v-select dir="rtl" label="title" placeholder="منشن" multiple chips @option:selected="onchangeUserListForMention" :options="LocalUserListForMention" :reduce="p => p.userId" v-model="checkListModel.mentionUserIdsList">
							<template slot="option">
								<div class="d-center">
									{{ option.title }}
								</div>
							</template>
						</v-select>
					</div>

					<div class="mb-3">
						<div class="d-flex">
							<div class="w-100">
								<v-select dir="rtl" v-model="checkListModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
									<template v-slot="option">
										<div class="d-center">
											{{ option.fullTitle }}
										</div>
									</template>
								</v-select>
							</div>
						</div>
					</div>

					<div v-if="!isMinVersion" class="collapse" id="collapse-moreDetails">
					
						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
										<template v-slot="option">
											<div class="d-center">
												{{ option.title }}
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						
						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="checkListModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>
					</div>
					<button v-if="!isMinVersion" data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
						<span class="collapse-a-title"></span>
					</button>
					<button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-3 btn-full bg-highlight rounded-sm font-900 w-100" @click.prevent="Share">
						<i class="fa fa-share-alt font-10 ml-2"></i>
						اشترک گذاری
					</button>
					<button :disabled="saveLoading" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="addNewFolder()">
						<i class="fa fa-plus font-14"></i>
						افزودن کار
					</button>

					<button :disabled="saveLoading" class="btn btn-xxs my-3 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="saveHeader()">
						<i class="fa fa-check font-14"></i>
						ثبت
					</button>





					<!--<div class="card card-style mx-0 mb-3">
		<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
			<a class="pr-1" data-toggle="collapse" href="#collapse-description">
				<i class="fa fa-edit mt-2"></i>
				<span>توضیحات</span>
				<i class="fa fa-angle-down"></i>
			</a>
		</div>
		<div class="collapse collapse-reminderCalendars" id="collapse-description">
			<textarea v-model="checkListModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px"></textarea>

		</div>
	</div>-->
					<!--<button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateCheckList">
		<i class="fa fa-check font-10 ml-2"></i>
		ثبت
	</button>-->


				</div>

			</div>
			<div class="card bg-20 mt-0 mb-n4 content pt-3 pb-5 shadow-l mx-0">
				<div class="card-body d-flex justify-content-between">
					<span class="color-white font-22">لیست کارها</span>
					<span class="color-white font-22"><i class="fa fa-percent ml-3 font-18"></i>{{passedRate}}</span>
				</div>
				<div class="card-overlay bg-highlight opacity-95 shadow-l"></div>
				<div class="card-overlay dark-mode-tint shadow-l"></div>
			</div>
			<div class="card card-style mt-n5 z-index2">
				<div class="content mb-0 mt-0">
					<draggable v-model="checkListModel.checkListFolderList" item-key="checkListFolderId" @change="sortFolders" handle=".btn-drag">
						<template #item="{element}">
							<div class="d-flex justify-content-between align-items-center checkLList-list">
								<div class="btn-drag" style="width:6%">
									<i class="fa fa-grip-vertical"></i>
								</div>
								<div class="d-flex align-items-center" style="width:60%" @click="setAsDone(element)">
									<input type="checkBox" :checked="element.passed===true" style=" filter: brightness(100%)!important" />
									<div class="mr-3 py-2 d-flex align-items-start flex-column justify-content-center">
										<del v-if="element.passed===true" class="text-muted">{{element.subject}}</del>
										<span v-else class="font-weight-bold">{{element.subject}}</span>

										<del v-if="element.passed===true" class="text-muted d-inline-block ltr text-left">{{element.reminderDateTime}}</del>
										<span v-else class="font-weight-bold d-inline-block ltr text-left text-warning">{{element.reminderDateTime}}</span>

									</div>
								</div>
								<div>
									<div class="badge bg-blue2-light mt-0 px-2 py-2" @click="setEditing(element)"><b class="fa fa-edit"></b></div>
									<div class="badge bg-red2-dark mt-0 px-2 py-2 mr-1" @click="deleteFolder(element)"><b class="fa fa-trash"></b></div>
									<!-- <div class="badge bg-green2-dark mt-0 px-2 py-2 mr-1" @click="openMoveModal(element)"><b class="fa fa-share-square"></b></div> -->

								</div>
							</div>

						</template>
					</draggable>

				</div>
			</div>


		</div>
		<date-picker type="date" v-model="checkListModel.checkListDate" format="jYYYY/jMM/jDD" element="endDT" />



		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">

			</div>
		</transition>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading2==true" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
		<Help-Menu title="راهنمای ثبت چک لیست" keyEn="TaskList"></Help-Menu>
		<!--<div id="createCheckListHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">راهنمای ثبت چک لیست</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="true">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3 show" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CheckList.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CheckList.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->


	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import { maska } from 'maska'
	import DatePicker from 'vue3-persian-datetime-picker';
	import folderModal from './FolderModal.vue'
	import moveListModal from './MoveListModal.vue'
	import HelpMenu from '../Components/HelpMenu.vue';
	import draggable from 'vuedraggable'
	import VueSimpleAlert from "vue3-simple-alert";
	export default {
		components: {
			DatePicker,
			"checkListFolder-modal": folderModal,
			"Help-Menu": HelpMenu,
			"checkListMoveList-modal": moveListModal,
			draggable,
		},
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				passedRate: 0,
				attInProgress: false,
				modified: false,
				pageLoaded: false,
				saveLoading: false,
				pageLoading2: false,
				showFolderModal: false,
				showMoveListModal: false,
				selectedFolder: null,
				checkListModel: {
					subject: null,
					checkListId: 0,
					userId: 0,
					description: " ",
					checkListDate: null,
					checkListFolderList: [],
					mentionUserIdsList: [],


					workGroupId: null,
					projectId: null,
					invoiceId: null,
					preInvoiceId: null,
					contractId: null,
					letterId: null,
					personId: null,
					meetingId: null,
					preBuyInvoiceId: null,
					buyId: null,

					projectTitle: null,
					preInvoiceTitle: null,
					invoiceTitle: null,
					letterTitle: null,
					buyTitle: null,
					contractTitle: null,
					personTitle: null,
					meetingTitle: null,
					preBuyInvoiceTitle: null,
					leadTitle: null,
					isLoad: false,
				},
				checkListFolderModel: {
					seq: 0,
					subject: null,
					sendReminder: false,
					reminderDateTime: null,
					passed: false,
					disabled: false,
					edited: false,
					editing: false,
					checkListId: 0,
					checkListFolderId: 0,
					checkListSubject: null,
					checkListDate: null,

				},

			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			checkListTypeList() {
				return this.$store.getters.GetCheckListTypeList;
			},
			propsToWatch() {
				return `${this.checkListModel.subject}|${this.checkListModel.description}`;
			},
			localUserListList() {
				return this.$store.getters.GetLocalUserListList;
			}
			,
			PersonList() {
				return this.$store.getters.GetPersonList;
			},
			ProjectList() {
				return this.$store.getters.GetProjectList;
			},
			PreInvoiceList() {
				return this.$store.getters.GetPreInvoiceList;
			},
			ContractList() {
				return this.$store.getters.GetContractList;
			},
			InvoiceList() {
				return this.$store.getters.GetInvoiceList;
			},
			LetterList() {
				return this.$store.getters.GetLetterList;
			},
			MeetingList() {
				return this.$store.getters.GetMeetingList;
			},
			PreBuyInvoiceList() {
				return this.$store.getters.GetPreBuyInvoiceList;
			},
			BuyList() {
				return this.$store.getters.GetBuyList;
			},
			LocalUserListForMention() {
				return this.$store.getters.GetLocalUserListForMention;
			},
			WorkGroupList() {
				return this.$store.getters.GetWorkGroupList;
			},
			HasCom() {
				return this.$store.getters.GetHasCom;
			},
		},
		watch: {
			localUserListList: {
				//handler: function () {
				//}
			},
			'checkListModel.workGroupId'(value) {
				if (this.checkListModel.isLoad)
					this.onChangeWorkGroup();
			},
			'checkListModel.personId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangePerson();
			},
			'checkListModel.projectId'(value) {
                if (this.checkListModel.isLoad)
					this.onchangeProject();
			},
			'checkListModel.preInvoiceId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangePreInvoice();
			},
			'checkListModel.contractId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangeContract();
			},
			'checkListModel.meetingId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangeMeeting();
			},
			'checkListModel.invoiceId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangeInvoice();
			},
			'checkListModel.letterId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangeLetter();
			},
			'checkListModel.buyId'(value) {
				if (this.checkListModel.isLoad)
					this.onchangeBuy();
			},
		},
		created() {

			this.$http.get("Task/TaskOnline_GetUserActiveStatus")
				.then(data => {
					if (data.data.expired)
						document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");

				});
			if (this.$route.params.checkListId != null && this.$route.params.checkListId != 0) {
				this.GetCheckListItem(this.$route.params.checkListId);

			}
			else {
				this.$store.dispatch("GetPersonListFromServer", {});
				this.$store.dispatch("GetProjectListFromServer", {});
				this.$store.dispatch("GetLocalUserListForMention", {});
				this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
				this.$store.dispatch("GetContractAbstractForPerson", {});
				this.$store.dispatch("GetInvoiceAbstractForPerson", {});
				this.$store.dispatch("GetLetterAbstractForPerson", {});
				this.$store.dispatch("GetMeetingAbstractForPerson", {});
				this.$store.dispatch("GetBuyAbstractForPerson", {});
				this.$store.dispatch("GetWorkGroupListFromServer", {});
				this.checkListModel.isLoad = true;
				this.getServerDateTime();
			}
			this.getUserList();

		},


		methods: {
			PersonFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetPersonListFromServer", {
						text: queryText,
					});
				return this.$store.getters.GetPersonList;
			},
			onchangePerson() {
				this.checkListModel.projectId = null;
				this.checkListModel.invoiceId = null;
				this.checkListModel.preInvoiceId = null;
				this.checkListModel.contractId = null;
				this.checkListModel.letterId = null;
				this.checkListModel.meetingId = null;
				this.checkListModel.preBuyInvoiceId = null;
				this.checkListModel.buyId = null;
				this.$store.dispatch("GetProjectListFromServer", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetContractAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetLetterAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.checkListModel.personId,
				});
				//this.saveHeader();
			},


			ProjectFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetProjectListFromServer", {
						text: queryText,
						personId: this.checkListModel.personId,
					});
				return this.$store.getters.GetProjectList;
			},
			onchangeProject() {
				this.checkListModel.contractId = null;
				this.checkListModel.meetingId = null;
				this.$store.dispatch("GetContractAbstractForPerson", {
					text: "",
					personId: this.checkListModel.personId,
					projectId: this.checkListModel.projectId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.checkListModel.personId,
					projectId: this.checkListModel.projectId,
				});
				//this.saveHeader();
			},


			PreInvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
						text: queryText,
						personId: this.checkListModel.personId,
						projectId: this.checkListModel.projectId,
					});
				return this.$store.getters.GetPreInvoiceList;
			},
			onchangePreInvoice() {
				//this.checkListModel.contractId = null;
				this.checkListModel.invoiceId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.checkListModel.preInvoiceId,
					contractId: this.checkListModel.contractId,
					personId: this.checkListModel.personId,
				});
				//this.saveHeader();
			},



			ContractFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetContractAbstractForPerson", {
						text: queryText,
						personId: this.checkListModel.personId,
					});
				return this.$store.getters.GetContractList;
			},
			onchangeContract() {
				this.checkListModel.invoiceId = null;
				this.checkListModel.buyId = null;
				this.checkListModel.meetingId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.checkListModel.preInvoiceId,
					contractId: this.checkListModel.contractId,
					personId: this.checkListModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.checkListModel.personId,
					projectId: this.checkListModel.projectId,
					contractId: this.checkListModel.contractId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.checkListModel.personId,
					prebuyInvoiceId: this.checkListModel.prebuyInvoiceId,
					contractId: this.checkListModel.contractId,
				});
				//this.saveHeader();
			},



			InvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetInvoiceAbstractForPerson", {
						text: queryText,
						preInvoiceId: this.checkListModel.preInvoiceId,
						contractId: this.checkListModel.contractId,
						personId: this.checkListModel.personId,
					});
				return this.$store.getters.GetInvoiceList;
			},
			onchangeInvoice() {
				//this.saveHeader();
			},



			LetterFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetLetterAbstractForPerson", {
						text: queryText,
						letterId: this.checkListModel.letterId,
						personId: this.checkListModel.personId,
					});
				return this.$store.getters.GetLetterList;
			},
			onchangeLetter() {
				//this.saveHeader();
			},



			MeetingFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetMeetingAbstractForPerson", {
						text: queryText,
						personId: this.checkListModel.personId,
						contractId: this.checkListModel.contractId,
						projectId: this.checkListModel.projectId,
					});
				return this.$store.getters.GetMeetingList;
			},
			onchangeMeeting() {
				//this.saveHeader();
			},

			BuyFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetBuyAbstractForPerson", {
						text: queryText,
						personId: this.checkListModel.personId,
						prebuyInvoiceId: this.checkListModel.prebuyInvoiceId,
						contractId: this.checkListModel.contractId,
					});
				return this.$store.getters.GetBuyList;
			},
			onchangeBuy() {
				// this.saveHeader();
			},




			onChangeWorkGroup() {
				this.checkListModel.mentionUserIdsList = [];
				this.checkListModel.userId = null;
				this.$store.dispatch("GetLocalUserListListFromServer", {
					workGroupId: this.checkListModel.workGroupId
				}).then(x => {
					this.$store.dispatch("GetLocalUserListForMention", {
						workGroupId: this.checkListModel.workGroupId
					}).then(x => {
						//this.saveHeader();
					});
				});

			},


			onchangeUserListForMention() {
				//this.saveHeader();
			},

			Share() {
				if (this.checkListModel.checkListId == null || this.checkListModel.checkListId == 0) {
					this.showErrorMessage("ابتدا چک لیست را ثبت کنید");
					return;
				}
				VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.pageLoading2 = true;
					var data = {
						shareDoc: 4,
						id: this.checkListModel.checkListId
					};
					this.$http.post("CheckList/ShareDoc", data)
						.then(data => {
							this.pageLoading2 = false;
							var res = data.data;
							if (res.isSuccess) {
								window.open(res.obj, '_blank');
							} else {
								this.showErrorMessage(res.message);
							}
						});
				});
			},
			getCheckListPassedRateById() {
				this.$http.get("CheckList/GetCheckListPassedRateById?id=" + this.checkListModel.checkListId)
					.then(data => {
						this.passedRate = data.data;
						this.checkListModel.isLoad = true;
					});
			},
			getUserList() {
				this.$store.dispatch("GetLocalUserListListFromServer", {});
				this.$http.get("Account/GetLogginedUserID")
					.then(data => {
						this.checkListModel.userId = data.data;
						this.$http.get("Task/TaskOnline_GetUserActiveStatus")
							.then(data => {
								if (data.data.expired)
									document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");
								else {

									setTimeout(function () {
										document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "block");
									}, 1000)
								}
							});

					});
			},
			addNewFolder() {
				this.saveOnlyHeader(false);
				var obj = {
					subject: null,
					sendReminder: false,
					reminderDateTime: null,
					passed: false,
					disabled: false,
					edited: false,
					editing: true,
					checkListFolderId: 0,
					seq: this.checkListModel.checkListFolderList.length + 1
				};
				console.log(this.checkListModel.checkListFolderList);
				this.selectedFolder = obj;
				this.v$.$touch();
				if (!this.v$.$invalid) {
					this.showFolderModal = true;
				}

			},
			saveFolderChanges(c) {

				this.saveLoading = true;
				c.checkListSubject = this.checkListModel.subject;
				c.checkListDate = this.checkListModel.checkListDate;
				c.checkListId = this.checkListModel.checkListId;
				c.passed = (c.passed === 'true' || c.passed === true);
				this.$http.post("CheckList/SaveFolder", c)
					.then(data => {
						this.saveLoading = false;
						if (isNaN(data.data)) {
							this.showMessage(data.data);
							this.getCheckListPassedRateById();
							this.GetCheckListItem(data.data);

						}
						else {
							this.showSuccessMessage("با موفقیت ذخیره شد.");
							this.showFolderModal = false;
							this.getCheckListPassedRateById();
							this.GetCheckListItem(data.data);
						}

					});

			},
			deleteFolder(c) {


				VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.saveLoading = true;
					this.$http.get("CheckList/DeleteFolder?id=" + c.checkListFolderId)
						.then(data => {
							this.saveLoading = false;
							if (data.data != "1") {
								this.showMessage(data.data);

							}
							else {
								this.showSuccessMessage("با موفقیت ذخیره شد.");
								this.GetCheckListFolders();
							}

						});
				});


			},
			showAddButton() {
				this.pageLoaded = true;

			},
			GetCheckListFolders() {
				this.$http.get("CheckList/GetCheckListItem?id=" + this.checkListModel.checkListId).then(data => {
					this.checkListModel.checkListFolderList = data.data.checkListFolderList;
				})
			},
			GetCheckListItem(id) {
				this.$http.get("CheckList/GetCheckListItem?id=" + id)
					.then(data => {
						this.$store.dispatch("GetPersonListFromServer", {
							text: "",
							personId: data.data.personId,
						}).then(a => {

							this.$store.dispatch("GetProjectListFromServer", {
								text: "",
								personId: data.data.personId,
								projectId: data.data.projectId,
							}).then(b => {
								this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
									text: "",
									personId: data.data.personId,
									preInvoiceId: data.data.preInvoiceId,
								}).then(c => {
									this.$store.dispatch("GetContractAbstractForPerson", {
										personId: data.data.personId,
										projectId: data.data.projectId,
										contractId: data.data.contractId,
									}).then(d => {
										this.$store.dispatch("GetInvoiceAbstractForPerson", {
											invoiceId: data.data.invoiceId,
											preInvoiceId: data.data.preInvoiceId,
											contractId: data.data.contractId,
											personId: data.data.personId,
										}).then(e => {
											this.$store.dispatch("GetLetterAbstractForPerson", {
												letterId: data.data.letterId,
												personId: data.data.personId,
											}).then(f => {
												this.$store.dispatch("GetMeetingAbstractForPerson", {
													personId: data.data.personId,
													contractId: data.data.contractId,
													projectId: data.data.projectId,
													meetingId: data.data.meetingId,
												}).then(g => {
													this.$store.dispatch("GetBuyAbstractForPerson", {
														personId: data.data.personId,
														prebuyInvoiceId: data.data.prebuyInvoiceId,
														buyId: data.data.buyId,
														contractId: data.data.contractId,
													}).then(h => {
														this.$store.dispatch("GetWorkGroupListFromServer", {
															workGroupId: data.data.workGroupId
														}).then(i => {
															this.$store.dispatch("GetLocalUserListListFromServer", {
																workGroupId: data.data.workGroupId
															}).then(j => {

																this.$store.dispatch("GetLocalUserListForMention", {
																	workGroupId: data.data.workGroupId
																}).then(k => {
																	this.checkListModel = data.data;
																	this.checkListModel.checkListFolderList = data.data.checkListFolderList;
																	this.modified = false;
																	this.getCheckListPassedRateById();
																	console.log(this.checkListModel.checkListFolderList);
																});
															});
														});
													});
												});
											});
										});
									});
								});
							});
						});
						this.modified = false
					});
			},
			setEditing(c) {
				c.editing = true;
				this.selectedFolder = c;
				this.showFolderModal = true;

			},
			openMoveModal(item) {
				this.selectedFolder = item;
				this.showMoveListModal = true;
			},
			removeFolder(c) {
				VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					c.subject = null;
					this.saveFolderChanges(c);
				});
			},
			setAsDone(c) {
				c.passed = (c.passed === 'true' || c.passed === true);
				c.passed = !c.passed;
				this.saveFolderChanges(c);
			},
			setShowFolderModal() {
				this.showFolderModal = true;
			},
			moveFolder(checkListId) {
				console.log(checkListId);
				this.showMoveListModal = false;
				this.$http.get("CheckList/MoveFolderToCheckList?folderId=" + this.selectedFolder.checkListFolderId + "&checkListId=" + checkListId)
					.then(data => {
						if (data.data == "1") {
							this.showSuccessMessage("انتقال آیتم به چک لیست انتخاب شده با موفقیت انجام شد.");
							this.GetCheckListItem(this.checkListModel.checkListId);
						}
						else {
							this.showErrorMessage(data.data);
						}
					});
			},
			getServerDateTime() {
				this.$http.get("Task/GetServerDateTime")
					.then(data => {
						this.checkListModel.checkListDate = data.data.split("_")[0];
					});

			},
			saveHeader(showLoad = true) {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
					this.$http.post("CheckList/CheckListCreate", this.checkListModel)
						.then(data => {
							this.saveLoading = false;
							if (isNaN(data.data)) {
								this.showErrorMessage(data.data);
								this.showFolderModal = false;
							}
							else {
								if (showLoad)
									this.showSuccessMessage("با موفقیت ذخیره شد.");
								this.GetCheckListItem(data.data);
								this.$store.commit("SetUpdateCheckListList", true);
							}
						});
				}
			},
			saveOnlyHeader(showLoad = true) {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
					this.$http.post("CheckList/CheckListCreateHeader", this.checkListModel)
						.then(data => {
							this.saveLoading = false;
							if (isNaN(data.data)) {
								this.showErrorMessage(data.data);
								this.showFolderModal = false;
							}
							else {
								if (showLoad)
									this.showSuccessMessage("با موفقیت ذخیره شد.");
								this.GetCheckListItem(data.data);
								this.$store.commit("SetUpdateCheckListList", true);
							}
						});
				}
			},

			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
			sortFolders() {
				this.checkListModel.passed = (this.checkListModel.passed === 'true' || this.checkListModel.passed === true);
				this.$http.post("CheckList/SortFolders", this.checkListModel)
					.then(response => {
						this.saveLoading = false;
						console.log(response);
					})

			},
			toggleClasslessDetails() {
				var element = document.getElementById("moreLessDetails");
				element.classList.toggle("lessDetails");
			},

		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
			this.showAddButton();
		},
		validations: {
			checkListModel: {
				subject: {
					required,
				},
				checkListDate: {
					required,
				},
				userId: {
					required,
				}
			},



		},
		directives: { maska },


	};
</script>

<style>
	.draggable-container {
		position: absolute;
		z-index: 9;
	}

	.draggable-header {
		z-index: 10;
	}
</style>
